export const PRODUCTS_IDS = {
  SETUP: 'SETUP',
};
